import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import coverSrc from 'assets/img/generic/04.jpg';
import defaultAvatar from 'assets/img/team/avatar.png';
import google from 'assets/img/logos/g.png';
import apple from 'assets/img/logos/apple.png';
import hp from 'assets/img/logos/hp.png';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProfileBanner from 'components/pages/user/ProfileBanner';
import VerifiedBadge from 'components/common/VerifiedBadge';

const WODProfileBanner = ({profile}) => {
  console.log(profile);
  const [avatar, setAvatar] = useState(profile?.avatar || defaultAvatar);  
  const [rightSidedItems] = useState([
    {
      title: 'Google',
      image: google
    },
    {
      title: 'Apple',
      image: apple
    },
    {
      title: ' Hewlett Packard',
      image: hp
    }
  ]);
  return (
    <ProfileBanner>
      <ProfileBanner.Header avatar={avatar} coverSrc={coverSrc} />
      <ProfileBanner.Body>
        <Row>
          <Col lg={8}>
            <h4 className="mb-1">
              {profile?.firstName} {profile?.lastName} <VerifiedBadge />
            </h4>
            <h5 className="fs-0 fw-normal">
            </h5>
            <p className="text-500"></p>
            <div className="border-dashed-bottom my-4 d-lg-none" />
          </Col>
          <Col className="ps-2 ps-lg-3">
            <Link to="#!">
              <Flex alignItems="center" className="mb-2">
                <FontAwesomeIcon
                  icon="envelope"
                  className="fs-3 me-2 text-700"
                />
                <div className="flex-1">
                  <h6 className="mb-0">{profile?.email}</h6>
                </div>
              </Flex>
            </Link>
            <Link to="#!">
              <Flex alignItems="center" className="mb-2">
                <FontAwesomeIcon icon="mobile" className="fs-3 me-2 text-700" />
                <div className="flex-1">
                  <h6 className="mb-0">{profile?.personalMobile}</h6>
                </div>
              </Flex>
            </Link>
          </Col>
        </Row>
      </ProfileBanner.Body>
    </ProfileBanner>
  );
};

export default WODProfileBanner;
